import {IAction} from '../../interfaces/action';
import {UPDATE_MAP_BOUNDS} from '../../constants/actions';

/**
 * Update the bounds
 */
export default function(mapBounds: ol.extent): IAction {
  return {
    type: UPDATE_MAP_BOUNDS,
    mapBounds
  };
}
